// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, X } from 'lucide-react'; // Import icons from lucide-react

const HeaderWrapper = styled.header`
  background-color: #0C2340;
  padding: 20px;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled(Link)`
  color: #AE9142;
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;
  z-index: 2;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0C2340;
    padding-top: 80px;
    z-index: 1;
  }
`;

const NavLink = styled(Link)`
  color: #AE9142;
  text-decoration: none;
  margin-left: 20px;
  &:hover {
    color: #00843D;
  }

  @media (max-width: 768px) {
    margin: 10px 0;
    font-size: 1.2rem;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #AE9142;
  cursor: pointer;
  padding: 0;
  z-index: 2;

  @media (max-width: 768px) {
    display: block;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <HeaderWrapper>
      <Nav>
        <Logo to="/" onClick={closeMenu}>Shamrock Services</Logo>
        <MenuButton onClick={toggleMenu}>
          {isOpen ? <X /> : <Menu />}
        </MenuButton>
        <NavLinks isOpen={isOpen}>
          <NavLink to="/" onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu}>About Us</NavLink>
          <NavLink to="/services" onClick={closeMenu}>Services</NavLink>
          <NavLink to="/projects" onClick={closeMenu}>Projects</NavLink>
          <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
        </NavLinks>
      </Nav>
    </HeaderWrapper>
  );
};

export default Header;